import {ForYouOpenType} from "../types/ForYouOpenType";

export const getOpenFromSimpleString = (type?: ForYouOpenType) => {
    switch (type) {
        case ForYouOpenType.BANNER:
            return "banner";
        case ForYouOpenType.TILE:
            return "tile";
        case ForYouOpenType.WIDGET:
            return "widget";
        default:
            return undefined;
    }
};

export const getOpenFromLeadString = (type?: ForYouOpenType) => {
    switch (type) {
        case ForYouOpenType.BANNER:
            return "find_for_you_banner";
        case ForYouOpenType.TILE:
            return "find_for_you_tile";
        case ForYouOpenType.WIDGET:
            return "find_for_you_widget";
        default:
            return "find_for_you";
    }
};
import {ForYouOpenType} from "../types/ForYouOpenType";

export const getOpenFromSimpleString = (type?: ForYouOpenType) => {
    switch (type) {
        case ForYouOpenType.BANNER:
            return "banner";
        case ForYouOpenType.TILE:
            return "tile";
        case ForYouOpenType.WIDGET:
            return "widget";
        default:
            return undefined;
    }
};

export const getOpenFromLeadString = (type?: ForYouOpenType) => {
    switch (type) {
        case ForYouOpenType.BANNER:
            return "find_for_you_banner";
        case ForYouOpenType.TILE:
            return "find_for_you_tile";
        case ForYouOpenType.WIDGET:
            return "find_for_you_widget";
        default:
            return "find_for_you";
    }
};
